/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetAccommodationsSuccessfulActionPayload,
  GetAccommodationByIdActionPayload,
  GetAccommodationByIdSuccessfulActionPayload,
  GetActiveAccommodationWithRelationsByIdActionPayload,
  GetActiveAccommodationByIdWithRelationsSuccessfulActionPayload,
  CreateAccommodationActionPayload,
  CreateAccommodationSuccessfulActionPayload,
  UpdateAccommodationActionPayload,
  UpdateAccommodationSuccessfulActionPayload,
  DeleteAccommodationActionPayload,
  DeleteAccommodationSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/accommodation-data-store';

/* action types */
export enum ActionTypes {
  InitFetchingActiveAccommodationWithRelations = '[ACCOMMODATION] InitFetchingActiveAccommodationWithRelations',
  GetAccommodations = '[ACCOMMODATION] GetAccommodations',
  GetAccommodationsSuccessful = '[ACCOMMODATION] GetAccommodationsSuccessful',
  GetAccommodationsFailure = '[ACCOMMODATION] GetAccommodationsFailure',
  GetAccommodationById = '[ACCOMMODATION] GetAccommodationById',
  GetAccommodationByIdSuccessful = '[ACCOMMODATION] GetAccommodationByIdSuccessful',
  GetAccommodationByIdFailure = '[ACCOMMODATION] GetAccommodationByIdFailure',
  GetActiveAccommodationWithRelationsById = '[ACCOMMODATION] GetActiveAccommodationWithRelationsById',
  GetActiveAccommodationByIdWithRelationsSuccessful = '[ACCOMMODATION] GetActiveAccommodationByIdWithRelationsSuccessful',
  GetActiveAccommodationByIdWithRelationsFailure = '[ACCOMMODATION] GetActiveAccommodationByIdWithRelationsFailure',
  CreateAccommodation = '[ACCOMMODATION] CreateAccommodation',
  CreateAccommodationSuccessful = '[ACCOMMODATION] CreateAccommodationSuccessful',
  CreateAccommodationFailure = '[ACCOMMODATION] CreateAccommodationFailure',
  UpdateAccommodation = '[ACCOMMODATION] UpdateAccommodation',
  UpdateAccommodationSuccessful = '[ACCOMMODATION] UpdateAccommodationSuccessful',
  UpdateAccommodationFailure = '[ACCOMMODATION] UpdateAccommodationFailure',
  DeleteAccommodation = '[ACCOMMODATION] DeleteAccommodation',
  DeleteAccommodationSuccessful = '[ACCOMMODATION] DeleteAccommodationSuccessful',
  DeleteAccommodationFailure = '[ACCOMMODATION] DeleteAccommodationFailure',
  ResetState = '[ACCOMMODATION] ResetState',
}

/* actions */

export const InitFetchingActiveAccommodationWithRelations = createAction(
  ActionTypes.InitFetchingActiveAccommodationWithRelations,
);

/* This event gets the all Accommodations. */
export const GetAccommodations = createAction(ActionTypes.GetAccommodations);

/* This event is fired after getting all the Accommodations successfully. */
export const GetAccommodationsSuccessful = createAction(
  ActionTypes.GetAccommodationsSuccessful,
  props<{ payload: GetAccommodationsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Accommodations. */
export const GetAccommodationsFailure = createAction(
  ActionTypes.GetAccommodationsFailure,
);

/* This event gets the Accommodation by Accommodation id. */
export const GetAccommodationById = createAction(
  ActionTypes.GetAccommodationById,
  props<{ payload: GetAccommodationByIdActionPayload }>(),
);

/* This event is fired after getting Accommodation by Accommodation id successfully. */
export const GetAccommodationByIdSuccessful = createAction(
  ActionTypes.GetAccommodationByIdSuccessful,
  props<{ payload: GetAccommodationByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Accommodation by Accommodation id. */
export const GetAccommodationByIdFailure = createAction(
  ActionTypes.GetAccommodationByIdFailure,
);

/* This event gets the active Accommodation by Accommodation id. */
export const GetActiveAccommodationWithRelationsById = createAction(
  ActionTypes.GetActiveAccommodationWithRelationsById,
  props<{ payload: GetActiveAccommodationWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting Accommodation by Accommodation id successfully. */
export const GetActiveAccommodationByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveAccommodationByIdWithRelationsSuccessful,
  props<{
    payload: GetActiveAccommodationByIdWithRelationsSuccessfulActionPayload;
  }>(),
);

/* This event is fired after couldn't get the Accommodation by Accommodation id. */
export const GetActiveAccommodationByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveAccommodationByIdWithRelationsFailure,
);

/* This event creates a Accommodation. */
export const CreateAccommodation = createAction(
  ActionTypes.CreateAccommodation,
  props<{ payload: CreateAccommodationActionPayload }>(),
);

/* This event is fired after creating a Accommodation successfully. */
export const CreateAccommodationSuccessful = createAction(
  ActionTypes.CreateAccommodationSuccessful,
  props<{ payload: CreateAccommodationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Accommodation successfully. */
export const CreateAccommodationFailure = createAction(
  ActionTypes.CreateAccommodationFailure,
);

/* This event updates a Accommodation. */
export const UpdateAccommodation = createAction(
  ActionTypes.UpdateAccommodation,
  props<{ payload: UpdateAccommodationActionPayload }>(),
);

/* This event is fired after updating a Accommodation successfully. */
export const UpdateAccommodationSuccessful = createAction(
  ActionTypes.UpdateAccommodationSuccessful,
  props<{ payload: UpdateAccommodationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Accommodation successfully. */
export const UpdateAccommodationFailure = createAction(
  ActionTypes.UpdateAccommodationFailure,
);

/* This event deletes a Accommodation. */
export const DeleteAccommodation = createAction(
  ActionTypes.DeleteAccommodation,
  props<{ payload: DeleteAccommodationActionPayload }>(),
);

/* This event is fired after deleting a Accommodation successfully. */
export const DeleteAccommodationSuccessful = createAction(
  ActionTypes.DeleteAccommodationSuccessful,
  props<{ payload: DeleteAccommodationSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Accommodation successfully. */
export const DeleteAccommodationFailure = createAction(
  ActionTypes.DeleteAccommodationFailure,
);

/* This event resets the Accommodation state. */
export const ResetState = createAction(ActionTypes.ResetState);
